import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {TranslateModule} from '@ngx-translate/core';
import {GenerateStoriesAiDialogComponent} from './generate-stories-ai-dialog.component';
import {
  ContentLoaderComponent,
  DialogCloseButtonComponent,
  InfoMessageComponent,
  PageLoaderComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent,
  Q9CreditBalanceWarningComponent
} from '@q9elements/ui-kit/components';
import {CustomFieldsFormComponent, ReleaseSelectComponent} from '@q9elements/ui-kit/changes/shared';
import {RequirementSelectComponent} from '@q9elements/ui-kit/changes/stories';
import {GenerateStoriesAIService} from './services/generate-stories-ai.service';
import {AssignStoriesContentComponent} from './components/assign-stories-content/assign-stories-content.component';
import {ExplainRulesContentComponent} from './components/explain-rules-content/explain-rules-content.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    TranslateModule,
    ReactiveFormsModule,
    InfoMessageComponent,
    SecondaryButtonComponent,
    PrimaryButtonComponent,
    CustomFieldsFormComponent,
    DialogCloseButtonComponent,
    RequirementSelectComponent,
    ReleaseSelectComponent,
    ContentLoaderComponent,
    PageLoaderComponent,
    ExplainRulesContentComponent,
    Q9CreditBalanceWarningComponent
  ],
  declarations: [GenerateStoriesAiDialogComponent, AssignStoriesContentComponent],
  exports: [GenerateStoriesAiDialogComponent],
  providers: [GenerateStoriesAIService]
})
export class GenerateStoriesAiDialogModule {}
